import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'antd';
import { useChangeAdsetStatusMutation } from 'store/redux/states/ad_adset/ad_adset.api';

const statuses = {
  active: true,
  disabled: false,
};

const AdsetStatusSwitch = (props) => {
  const [changeStatusQuery, { isLoading }] = useChangeAdsetStatusMutation();
  const { active, status, adsetId, ...rest } = props;

  const checked = Boolean(active || statuses[status]);

  const onChange = (active) => {
    changeStatusQuery({
      adset_id: adsetId,
      status: active ? 'active' : 'paused',
    }).unwrap();
  };

  return (
    <Switch
      size='small'
      checked={checked}
      onChange={onChange}
      isLoading={isLoading}
      disabled={isLoading}
      {...rest}
    />
  );
};

AdsetStatusSwitch.propTypes = {
  status: PropTypes.object.isRequired,
  adsetId: PropTypes.number.isRequired,
  active: PropTypes.bool,
};

export default AdsetStatusSwitch;
